import { useMutation, useQueryClient } from "react-query";
import { ECoursesQueryKeys } from "api/endpoints/courses";
import { detachCourseLessonFromGroup } from "api/services/courses";
import { logError } from "utils/notifications";
import { TDetachCourseLessonFromGroupBody } from "types/api/course";
import { TApiError } from "types/api/error";
import { TUrlParam } from "types/utils";

export const useDetachCourseLessonFromGroup = () => {
  const queryClient = useQueryClient();
  return useMutation<
    void,
    TApiError,
    {
      courseId: TUrlParam;
      lessonId: TUrlParam;
      body: TDetachCourseLessonFromGroupBody;
    }
  >(
    ({ courseId, lessonId, body }) =>
      detachCourseLessonFromGroup(courseId, lessonId, body),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(ECoursesQueryKeys.getAllCourseLessons);
      },
      onError: (error) => logError({ error }),
      retry: false,
    }
  );
};
